export default __webpack_public_path__ + "static/media/logo.8d72d2d6.png";